// @flow

import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import Tile from "./Tile";

type Props = {
  right: boolean,
  id: number,
  deleteTile: Function,
  editTile: Function,
};

const SortableItem = ({ id, right, deleteTile, editTile }: Props) => {
  const {
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    position: isDragging ? "relative" : undefined,
    zIndex: isDragging ? 9999 : undefined,
  };

  return (
    <Tile
      setNodeRef={setNodeRef}
      style={style}
      right={right}
      id={id}
      deleteTile={deleteTile}
      editTile={editTile}
      dragHandleRef={setActivatorNodeRef}
      dragHandleListeners={listeners}
    />
  );
};

export default SortableItem;
